'use client';

import { useEffect, useState } from 'react';
import { ErrorScreen } from '@/components/ui/ErrorScreen';

export function ConnectionMonitor() {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <ErrorScreen
      code="OFFLINE"
      label="NETWORK_FAILURE"
      title="You are currently disconnected."
      message="The connection to our agentic nodes was lost. Please check your network and attempt a reconnect."
      terminal="ping -c 4 8.8.8.8"
      showRetry={true}
    />
  );
}
